import { AppLoadingState } from "@/shared/components/AppLoadingState";

export function RouteLoadingState() {
  return <AppLoadingState />;
}
